// tslint:disable-next-line: max-classes-per-file
var Initial = /** @class */ (function () {
    function Initial() {
        this.error = null;
        this.isLoading = false;
        this.isResolved = false;
        this.value = null;
    }
    Initial.prototype.map = function (_) {
        return new Initial();
    };
    Initial.prototype.mapError = function (_) {
        return new Initial();
    };
    return Initial;
}());
export { Initial };
// tslint:disable-next-line: max-classes-per-file
var Success = /** @class */ (function () {
    function Success(value) {
        this.value = value;
        this.error = null;
        this.isLoading = false;
        this.isResolved = true;
    }
    Success.prototype.map = function (mapper) {
        return new Success(mapper(this.value));
    };
    Success.prototype.mapError = function (_) {
        return new Success(this.value);
    };
    return Success;
}());
export { Success };
// tslint:disable-next-line: max-classes-per-file
var Failure = /** @class */ (function () {
    function Failure(error) {
        this.error = error;
        this.isLoading = false;
        this.isResolved = true;
        this.value = null;
    }
    Failure.prototype.map = function (_) {
        return new Failure(this.error);
    };
    Failure.prototype.mapError = function (mapper) {
        return new Failure(mapper(this.error));
    };
    return Failure;
}());
export { Failure };
// tslint:disable-next-line: max-classes-per-file
var Loading = /** @class */ (function () {
    function Loading(value) {
        this.value = value;
        this.error = null;
        this.isLoading = true;
        this.isResolved = false;
    }
    Loading.prototype.map = function (mapper) {
        return new Loading(this.value !== null ? mapper(this.value) : null);
    };
    Loading.prototype.mapError = function (_) {
        return new Loading(this.value);
    };
    return Loading;
}());
export { Loading };
